import list from "./list";
import icon from '@mui/icons-material/PhonelinkRing';



const adminConfig = { list, icon };

export default adminConfig;